import ApiPermisos from './../../services/apiPermisos'

import { mapper } from './../../common/maps/map'

export default {
  namespaced: true,
  // state,
  // actions,
  // mutations,
  // getters
  state: {
      bps: [], //businessPartner
      request: [], //Solicitudes
      requestFree: [], //Solicitud de usuario sin credenciales
      requestsFree: [], //Solicitudes usuario sin credenciales
      workers: [],
      errorMsj: '',
      loading: false,
      dashboard: [],
      approvers: [],
      laborUnions: [],
      faq: [],
      availability: [],
      societiesHours: "",
      absenteeism: [],
      settings: [],
      sites: [],
      societies: [],
      dashboardBar: [],
      modals: [],
      notifications: [],
      cities: [],
      states: [],
      countries: [],
      holidays: [],
      allSites: [],
      historial: [],
      businessDate: []
      , limit_validation: {
          available: false
          , can_only_be_managed: null
          , requested_amount: 1
      }
  },
  getters: {
      getBusinessDate: state => state.businessDate
      , getLimitValidation: state => state.limit_validation
  },
  mutations: {
    setBusinessDate(state, businessDate){
        state.businessDate = businessDate
    }
    , setLimitValidation (state, {
        available
          , can_only_be_managed
          , requested_amount
    }) {
          state.limit_validation.available = available
          state.limit_validation.can_only_be_managed = can_only_be_managed
          state.limit_validation.requested_amount = requested_amount
    }
    ,setBPs: (state, BPs) => {
      state.bps = BPs;
    },
    setRequest: (state, request) => {
      state.request = request;
    },
    setRequestFree: (state, requestFree) => {
      state.requestFree = requestFree;
    },
    setRequestsFree: (state, requestsFree) => {
      state.requestsFree = requestsFree;
    },
    setWorkers: (state, workers) => {
        const employee = mapper(workers.data, 'city', 'id', 'cc', 'name', 'sharp_id', 'search')
       /* workers.data.map(function (employee) {
            return {
                city: employee.city,
                id: employee.id,
                cc: employee.cc,
                name: employee.name,
                sharp_id: employee.sharp_id,
                name_to_search: `Nombre: ${employee.name}  CC: ${employee.cc} SharpId: ${employee.sharp_id}`
            }
        })*/
        const approvers = mapper(workers.approvers,
            'id',
            'name',
            'sharp_id',
            'society_id',
            'site_id',
            'cc',
            'site',
            'society',
            'search')
        state.workers.data = employee
        state.workers.approvers = approvers
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
    setDashboard: (state, dashboard) => {
      state.dashboard = dashboard;
    },
    setApprovers: (state, approvers) => {
      state.approvers = approvers;
    },
    setLaborUnions: (state, laborUnions) => {
      state.laborUnions = laborUnions;
    },
    setFaq: (state, faq) => {
      state.faq = faq;
    },
    setAvailability: (state, availability) => {
      state.availability = availability;
    },
    setSocietiesHours: (state, societiesHours) => {
      state.societiesHours = societiesHours;
    },
    setAbsenteeisms: (state, absenteeism) => {
      state.absenteeism = absenteeism;
    },
    setSettings: (state, settings) => {
      state.settings = settings;
    },
    setSites: (state, sites) => {
      state.sites = sites;
    },
    setSocieties: (state, societies) => {
      state.societies = societies;
    },
    setDashboardBar: (state, dashboardBar) => {
      state.dashboardBar = dashboardBar;
    },
    setModals: (state, modals) => {
      state.modals = modals;
    },
    setNotifications: (state, notifications) => {
      state.notifications = notifications;
    },
    setCities: (state, cities) => {
      state.cities = cities;
    },
    setHolidays: (state, holidays) => {
      state.holidays = holidays;
    },
    setCountries: (state, countries) => {
      state.countries = countries;
    },     
    setStates: (state, states) => {
      state.states = states;
    },
    setAllSites: (state, allSites) => {
      state.allSites = allSites;
    },
    setHistory: (state, historial) => {
      state.historial = [];
      state.historial = historial;
    },
  },
  actions: {

    actGetBusinessDate: async ({ commit }, { date, ticket_type } ) => {
        try {
            let data = await ApiPermisos.GetBusinessDate({ date, ticket_type })
            commit('setBusinessDate', data.data)
        } catch (e) {
            console.log('Hay un error al intentar consultar')
        }
    },

    /*
     *
     * REQUEST 
     * 
     */
  //Trae todos los Business Partner
  actGetBP: async ({
    commit
    }, data) => {
        let response = await ApiPermisos.GetBP(data);
        //console.log(JSON.stringify(response));
        /*if (response.error) {
            return response;
        }*/
        commit('setBPs', response);
        return response;
    },

    //Trae la informacion de la solicitud
    actGetRequest: async ({
      commit
    }, data) => {
        //console.log(data);
        commit('setLoading', true); // Start loading
        let response = await ApiPermisos.GetRequest(data);
        commit('setLoading', false); // End loading
        if (response.error) {
            return response.error;
        }
        commit('setRequest', response);
        return true;
    },

    //Guarda la solicitud de permiso Sindical
    actSaveRequest: async ({
      commit
    }, data) => {
      commit('setLoading', true); // Start loading
      try {
        let response = await ApiPermisos.saveRequest(data);
        commit('errorMsj', response);
        if (response.error) {
          return response.error;
        }
        return response;
      } finally {
        commit('setLoading', false); // End loading
      }
    },

    async actRequestLimitValidation({ commit }, data) {
    const { result: {
        available
        , can_only_be_managed
        , requested_amount
    }} = await ApiPermisos.limitRequestValidation(data)
        commit('setLimitValidation', {
            available
            , can_only_be_managed
            , requested_amount
        })
    },

    //Guarda comentarios de solicitud de permiso Sindical
    actSaveComments: async ({
      commit
    }, data) => {
      let response = await ApiPermisos.saveComments(data);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },
    //Trae todos los Business Partner
    actGetWorkers: async ({
      commit
      }, data) => {        
        let response = await ApiPermisos.getWorkers(data);
        if (response.error) {
            return response.error;
        }
        commit('setWorkers', response);
        return true;
    },
    
    //Trae la informacion de una solicitud del free user (usuario sin credenciales)
    actGetRequestFree: async ({
      commit
    }, data) => {
        let id = data[0];
        let idUser = data[1];        
        commit('setLoading', true); // Start loading
        let response = await ApiPermisos.getRequestFree(id,idUser);
        commit('setLoading', false); // End loading
        if (response.error) {
            return response.error;
        }
        commit('setRequestFree', response);
        return true;
    },

    //Trae la informacion del free user (usuario sin credenciales)
    actGetRequestsFree: async ({
      commit
    }, cc) => {
        //console.log(data);
        commit('setLoading', true); // Start loading
        let response = await ApiPermisos.getRequestsFree(cc);
        commit('setLoading', false); // End loading
        if (response.error) {
            return response.error;
        }
        else{
          commit('setRequestsFree', response);
        }
        return true;
    },

    //Trae la informacion del dashboard
    actGetDashboard: async ({
      commit
    }, data) => {
        //console.log(data);
        commit('setLoading', true); // Start loading
        let response = await ApiPermisos.getDashboard(data);
        commit('setLoading', false); // End loading
        if (response.error) {
            return response.error;
        }
        else{
          commit('setDashboard', response);
        }
        return true;
    },

    //Actualiza estado de la Solicitud 
    /*actUpdateStateRequest: async ({
      commit
    }, data) => {
      let id = data[0];
      let status = data[1];
      let response = await ApiPermisos.updateStateRequest(id,status);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },*/

    //Actualiza estado de la Solicitud 
    actSetRequestStatus: async ({
      commit
    }, data) => {
      let id = data[0];
      let status = data[1];
      let response = await ApiPermisos.setRequestStatus(id,status);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },

    //Actualiza la informacion nuevo tiquete
    actUpdateRequestTkts: async ({
      commit
    }, data) => {
      let id = data[0];
      let datos = data[1];
      let response = await ApiPermisos.updateRequestTkts(id,datos);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },

    actApproverSggsted: async ({
      commit
      }, sharp_id) => {        
        let response = await ApiPermisos.approverSggsted(sharp_id);
        if (response.error) {
            return response.error;
        }
        commit('setApprovers', response);
        return true;
    },

    //Trae todos los Business Partner
    actGetLaborUnions: async ({
      commit
    }) => {
        let response = await ApiPermisos.getLaborUnions();
        if (response.error) {
            return response.error;
        }
        commit('setLaborUnions', response);
        return true;
    },

    //trae Help
    actGetFaq: async ({
      commit
    }) => {
        let response = await ApiPermisos.getFaq();
        if (response.error) {
            return response.error;
        }
        commit('setFaq', response);
        return true;
    },

    //Analiza la viabilidad de seguir creando solicitudes de permiso.
    actGetAvailability: async ({
      commit
    }, society) => {        
        let response = await ApiPermisos.getAvailability(society);
        commit('setAvailability', response);
        if (response.error) {
            return response.error;
        }        
        return true;
    },

    //Valida si la Sociedad puede pedir permiso por horas
    actGetSocietiesInfo: async ({
      commit
    }, sharp_id) => {
        let response = await ApiPermisos.getSocietiesInfo(sharp_id);
        if (response.error) {
            return response.error;
        }
        commit('setSocietiesHours', response);
        return true;
    },

    //Trae la informacion del free user (usuario sin credenciales)
    actGetAbsenteeism: async ({
      commit
    }, data) => {
        //console.log(data);
        //commit('setLoading', true); // Start loading
        let response = await ApiPermisos.getAbsenteeism(data);
        //commit('setLoading', false); // End loading
        if (response.error) {
            return response.error;
        }
        else{
          commit('setAbsenteeisms', response);
        }
        return true;
    },

    //Trae todos la disponibilidad de dias en los tiquetes nacionales e internacionales
    actGetSettings: async ({
    commit
    }) => {
        let response = await ApiPermisos.getSettings();
        if (response.error) {
            return response.error;
        }
        commit('setSettings', response);
        return true;
    },

    //Envia mail con archivos adjuntos
    actSendEmailDocs: async ({
      commit
    }, data) => {
      let id = data[0];
      let files = data[1];
      commit('setLoading', true); // Start loading
      let response = await ApiPermisos.sendEmailDocs(id,files);
      commit('setLoading', false); // End loading
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },

    //Trae todos los sites
    actGetSites: async ({
    commit
    }) => {
        let response = await ApiPermisos.getSites();
        if (response.error) {
            return response.error;
        }
        commit('setSites', response);
        return true;
    },

    //Trae todos los Sociedades
    actGetSocieties: async ({
    commit
    }) => {        
        let response = await ApiPermisos.getSocieties();
        if (response.error) {
            return response.error;
        }
        commit('setSocieties', response);
        return true;
    },

    //Trae todos los Sites
    actGetAllSitesBP: async ({
      commit
      }, id_bp) => {        
          let response = await ApiPermisos.getAllSitesBP(id_bp);
          if (response.error) {
              return response.error;
          }
          commit('setAllSites', response);
          return true;
      },

    //Trae el dashboardBar
    actGetDashboardBar: async ({
    commit
    }, data) => {          
        let response = await ApiPermisos.getDashboardBar(data);
        if (response.error) {
            return response.error;
        }
        commit('setDashboardBar', response);
        return true;
    },

    //Trae modales 
    actGetModals: async ({
      commit
      }, data) => {          
          let response = await ApiPermisos.getModals(data);
          if (response.error) {
              return response.error;
          }
          commit('setModals', response);
          return true;
      },
    
    //Trae Notifications 
    actGetNotifications: async ({
    commit
    }) => {      
      let response = await ApiPermisos.getNotifications();
      if (response.error) {
          return response.error;
      }
      commit('setNotifications', response);
      return true;
    },

    //Actualiza el estado de la notificacion
    actUpdateStateNtftn: async ({
      commit
    }, data) => {      
      let response = await ApiPermisos.updateStateNtftn(data);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },

    //Actualiza la lectura de la notificación
    actUpdateReadNtftn: async ({
      commit
    }, data) => {      
      let response = await ApiPermisos.updateReadNtftn(data);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },

    //Solicita revision de una solicitud por Notificación
    /*actRequestReview: async ({
      commit
    }, id) => {
      let response = await ApiPermisos.requestReview(id);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },*/

    //Guarda observación del formato de ausentismo
    actSaveObsAbse: async ({
      commit
    }, data) => {      
      let response = await ApiPermisos.saveObsAbse(data);
      commit('errorMsj', response);
      if (response.error) {
        return response.error;        
      }
      else{
        return response;
      }
    },

    //Trae ciudades 
    actGetCities: async ({
      commit
      }) => {          
          let response = await ApiPermisos.getCities();
          if (response.error) {
              return response.error;
          }
          commit('setCities', response);
          return true;
      },

    //Trae ciudades 
    actGetStates: async ({
      commit
      }) => {          
          let response = await ApiPermisos.getStates();
          if (response.error) {
              return response.error;
          }
          commit('setStates', response);
          return true;
      },

    //Trae paises 
    actGetCountries: async ({
      commit
      }) => {          
          let response = await ApiPermisos.getCountries();
          if (response.error) {
              return response.error;
          }
          commit('setCountries', response);
          return true;
      },

    //Valida holidays
    actCheckHoliday: async ({
      commit
      }, date) => {
        //prueba
          let response = await ApiPermisos.checkHoliday(date);
          commit('setHolidays', response);
          return response;
      },

    actGetHistorial: async ({
      commit
    }, data) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getReportHistory(data);
        if (response.error) {
            commit('setLoading', false);
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setHistory', response.data);
        }
        return response;
    },

  },
}
